import { Builder } from '@builder.io/sdk';
import { ReviewsCarousel } from './ReviewsCarousel';

const ReviewsCarouselConfig = {
  name: 'ReviewsCarousel',
  inputs: [
    {
      name: '_reviews',
      type: 'list',
      subFields: [
        {
          name: 'review',
          type: 'reference',
          model: 'review',
        },
      ],
    },
  ],
};

Builder.registerComponent(ReviewsCarousel, ReviewsCarouselConfig);
